import { render, staticRenderFns } from "./RestaurantPOS2.vue?vue&type=template&id=6700b336&scoped=true"
import script from "./RestaurantPOS2.vue?vue&type=script&lang=js"
export * from "./RestaurantPOS2.vue?vue&type=script&lang=js"
import style0 from "./RestaurantPOS2.vue?vue&type=style&index=0&id=6700b336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700b336",
  null
  
)

export default component.exports